import React from "react";

/**
 * One figure plus its label, as a `<dt>`/`<dd>` pair. Must be rendered inside
 * a `<dl>`.
 *
 * `flex-col-reverse` shows the value above the label while keeping the DOM
 * order label-then-value, so a screen reader announces "students supported,
 * 600 → 10 000" rather than a bare number with no context.
 *
 * `tabular-nums` keeps digit widths equal so a row of stats stays aligned
 * across the three locales.
 */
export default function StatCard({ value, label, tone = "light", index = 0 }) {
  const dark = tone === "dark";

  return (
    <div
      className="landing-reveal flex flex-col-reverse"
      data-reveal-index={index}
    >
      <dt className={`mt-3 leading-relaxed ${dark ? "text-gray-300" : "text-muted"}`}>
        {label}
      </dt>
      {/*
        Held at text-4xl rather than scaling to text-5xl on desktop. In a
        4-across row each cell is ~320px, and the longest value
        ("600 → ~10 000") wraps to two lines at 48px — which pushes that one
        label out of line with its neighbours. 36px fits on one line in all
        three locales.
      */}
      <dd
        className={`m-0 text-4xl font-bold leading-none tabular-nums ${
          dark ? "text-white" : "text-black-landing"
        }`}
      >
        {value}
      </dd>
    </div>
  );
}
